import { T } from './reportTokens';

type Props = {
    onRetry: () => void;
    supportHref?: string;
};

const ReportErrorState = ({ onRetry, supportHref = 'mailto:support@maghil.com' }: Props) => {
    return (
        <div
            role="alert"
            style={{
                flex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '32px 20px',
                background: T.bg,
                fontFamily: T.font,
            }}
        >
            <div style={{ maxWidth: 520, textAlign: 'center' }}>
                <div
                    aria-hidden
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginBottom: 18,
                    }}
                >
                    <svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke={T.t2} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0Z" />
                        <line x1="12" y1="9" x2="12" y2="13" />
                        <line x1="12" y1="17" x2="12.01" y2="17" />
                    </svg>
                </div>
                <div
                    style={{
                        fontSize: 22,
                        fontWeight: 700,
                        color: T.t1,
                        marginBottom: 10,
                        letterSpacing: '-0.01em',
                    }}
                >
                    Something went wrong
                </div>
                <div
                    style={{
                        fontSize: 14,
                        color: T.t2,
                        marginBottom: 24,
                        lineHeight: 1.5,
                    }}
                >
                    We couldn’t load this report. This is usually a temporary issue.
                </div>
                <button
                    type="button"
                    onClick={onRetry}
                    style={{
                        background: T.surface,
                        color: T.t1,
                        border: `1px solid ${T.cardBorder}`,
                        borderRadius: 8,
                        padding: '10px 28px',
                        fontSize: 14,
                        fontWeight: 600,
                        cursor: 'pointer',
                        fontFamily: T.font,
                        boxShadow: T.cardShadow,
                    }}
                >
                    Retry
                </button>
                <div
                    style={{
                        marginTop: 22,
                        fontSize: 13,
                        color: T.t3,
                    }}
                >
                    If this keeps happening,{' '}
                    <a
                        href={supportHref}
                        style={{ color: T.accent, textDecoration: 'none', fontWeight: 500 }}
                    >
                        contact Maghil support
                    </a>
                    .
                </div>
            </div>
        </div>
    );
};

export default ReportErrorState;
